import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login/Login';
import PrivacyPolicy from '../pages/Login/PrivacyPolicy';
import SignUp from '../pages/SignUp/SignUp';
import Home from '../pages/Home/Home';
import Layout from '../components/Layout/Layout';
import BreakdownContainer from '../pages/Home/BreakdownContainer';
import BreakdownPathRedirect from '../pages/Home/BreakdownPathRedirect';
import ElementsWorkspace from '../pages/Home/ElementsWorkspace';
import ScheduleRoutePage from '../pages/Home/ScheduleRoutePage';
import BudgetContainer from '../pages/Home/BudgetContainer';
import Schedule from '../pages/Schedule/Schedule';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';

const Router: React.FC = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/signup" element={<SignUp />} />
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Home />} />
          <Route path="/breakdown/:breakdownId" element={<BreakdownContainer />} />
          <Route path="/breakdown" element={<BreakdownPathRedirect />} />
          <Route path="/elements/:breakdownId" element={<ElementsWorkspace />} />
          <Route path="/budgets" element={<BudgetContainer />} />
          <Route path="/schedule/:scheduleID" element={<ScheduleRoutePage />} />
          <Route path="/schedule" element={<Schedule />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </HashRouter>
  );
};

export default Router;
